import { render, staticRenderFns } from "./TagListPopup.vue?vue&type=template&id=590584c8&"
import script from "./TagListPopup.vue?vue&type=script&lang=js&"
export * from "./TagListPopup.vue?vue&type=script&lang=js&"
import style0 from "./TagListPopup.vue?vue&type=style&index=0&id=590584c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports